import {
  useDeleteInteractionsByTripByTripIdCommentAndCommentIdMutation,
  useGetProfilesByUserIdQuery,
} from '../../../store/backendApi';

export interface CommentProps {
  id: string;
  name?: string;
  userId?: string;
  body: string;
  timeText: string;
  tripId: string;
  isOwner: boolean;
}

export const Comment = (props: CommentProps) => {
  const { data: profileData } = useGetProfilesByUserIdQuery(props.userId!, {
    skip: !props.userId,
  });

  const [deleteComment] = useDeleteInteractionsByTripByTripIdCommentAndCommentIdMutation();

  const displayName = props.name || profileData?.username || 'Anonymous';

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this comment?')) {
      try {
        await deleteComment({
          tripId: props.tripId,
          commentId: props.id,
        }).unwrap();
      } catch (error) {
        console.error('Failed to delete comment:', error);
      }
    }
  };

  return (
    <div
      className="w-full p-6 pt-4 pb-4 bg-white rounded-2xl border border-gray-200 flex-col justify-start
                 items-start flex gap-1"
    >
      <div className="w-full flex flex-row gap-2.5 flex-wrap">
        {props.userId ? (
          <a
            href={`/profile/${props.userId}`}
            className="inline-block rounded-full size-4 overflow-hidden bg-gray-100 hover:opacity-80 transition-opacity"
          >
            <img
              className="size-full object-cover"
              alt={displayName}
              src={`https://media.${process.env.REACT_APP_HOST}/users/${
                props.userId
              }-thumbnail.jpg?v=${Date.now()}`}
              onError={(e) => {
                // Fallback to default avatar if image fails to load
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent) {
                  parent.innerHTML = `
                    <svg fill="currentColor" viewBox="0 0 24 24" class="size-full text-gray-300">
                      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 
                      11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"/>
                    </svg>
                  `;
                }
              }}
            />
          </a>
        ) : (
          <span className="inline-block rounded-full size-4 overflow-hidden bg-gray-100">
            <svg fill="currentColor" viewBox="0 0 24 24" className="size-full text-gray-300">
              <path
                d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996
                    5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </span>
        )}
        {props.userId ? (
          <a
            href={`/profile/${props.userId}`}
            className="text-gray-900 text-xs font-bold hover:text-indigo-600 hover:underline transition-colors"
          >
            <p>{displayName}</p>
          </a>
        ) : (
          <p className="text-gray-900 text-xs font-bold">{displayName}</p>
        )}
        <p className="text-gray-500 text-xs whitespace-nowrap ml-auto">{props.timeText}</p>
        {props.isOwner && (
          <button
            onClick={handleDelete}
            className="ml-2 text-gray-400 hover:text-red-600 transition-colors"
            title="Delete comment"
            aria-label="Delete comment"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1
                1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </button>
        )}
      </div>

      <p className="w-full text-gray-800 text-sm font-normal leading-snug break-words">
        {props.body}
      </p>
    </div>
  );
};
